export enum DaysOfWeek {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}

export const daysOfWeekMap: Record<DaysOfWeek, string> = {
  [DaysOfWeek.Sunday]: 'Sunday',
  [DaysOfWeek.Monday]: 'Monday',
  [DaysOfWeek.Tuesday]: 'Tuesday',
  [DaysOfWeek.Wednesday]: 'Wednesday',
  [DaysOfWeek.Thursday]: 'Thursday',
  [DaysOfWeek.Friday]: 'Friday',
  [DaysOfWeek.Saturday]: 'Saturday',
};

export const daysOfWeekOptions = [
  { value: DaysOfWeek.Sunday, label: daysOfWeekMap[DaysOfWeek.Sunday] },
  { value: DaysOfWeek.Monday, label: daysOfWeekMap[DaysOfWeek.Monday] },
  { value: DaysOfWeek.Tuesday, label: daysOfWeekMap[DaysOfWeek.Tuesday] },
  { value: DaysOfWeek.Wednesday, label: daysOfWeekMap[DaysOfWeek.Wednesday] },
  { value: DaysOfWeek.Thursday, label: daysOfWeekMap[DaysOfWeek.Thursday] },
  { value: DaysOfWeek.Friday, label: daysOfWeekMap[DaysOfWeek.Friday] },
  { value: DaysOfWeek.Saturday, label: daysOfWeekMap[DaysOfWeek.Saturday] },
];
